




























































































import {
  FormFieldDefMap,
  makeValidatorDictionary,
} from '@/reusable/Form/formUtils';
import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';
import ModalMantenedor from '@/reusable/Modal/ModalMantenedor.vue';
import CabeceraModal from '@/reusable/Modal/CabeceraModal.vue';
import GuardarButton from '@/reusable/Modal/GuardarButton.vue';
import ContenidoModal from '@/reusable/Modal/ContenidoModal.vue';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import {
  Evaluaciones,
  ScriptValidacionRespuesta,
} from '@/interfaces/ContratoProveedor';
import CodeView from '@/reusable/CodeView/CodeView.vue';
import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';

import { evaluarScriptRespuesta } from '@/pantallas/ContratoProveedor/Services/evaluarScriptRespuesta';

@Component({
  components: {
    CabeceraModal,
    GuardarButton,
    ModalMantenedor,
    ContenidoModal,
    FormFieldsContainer,
    CodeView,
  },
})
export default class ValidarRespuestaModal extends Vue {
  @Prop({ default: false }) show!: boolean;
  @Prop({ required: true, default: '' }) script: string;

  readonly $snotify: Snotify;
  readonly loadingService = new LoadingService();

  formFields: FormFieldDefMap = {
    statusHttp1: {
      label: '',
      id: 'statusHttp1',
      value: '200',
    },
    statusHttp2: {
      label: '',
      id: 'statusHttp2',
      value: '200',
    },
    statusHttp3: {
      label: '',
      id: 'statusHttp3',
      value: '500',
    },
    respuesta1: {
      label: '',
      id: 'respuesta1',
      value: '<resp><cod>0</cod><msg>OK</msg></resp>',
    },
    respuesta2: {
      label: '',
      id: 'respuesta2',
      value: '<resp><cod>0</cod><msg>Error</msg></resp>',
    },
    respuesta3: {
      label: '',
      id: 'respuesta3',
      value: 'Sin body',
    },
    resultado1: {
      label: '',
      id: 'resultado1',
      value: '',
    },
    resultado2: {
      label: '',
      id: 'resultado2',
      value: '',
    },
    resultado3: {
      label: '',
      id: 'resultado3',
      value: '',
    },
    scriptValidar: {
      label: '',
      id: 'scriptValidar',
      value: '',
    },
  };

  handleCerrar() {
    this.$emit('cerrar');
  }

  @Watch('script', { deep: true })
  handleScriptChange() {
    if (this.script) {
      this.formFields.scriptValidar.value = this.script;
      this.handleValidarScriptClick();
    }
  }

  handleValidarScriptClick() {
    this.loadingService.showLoading();

    let scriptValidacionRespuesta: ScriptValidacionRespuesta = {
      script: this.formFields.scriptValidar.value.toString(),
      ejemplos: [
        {
          status: this.formFields.statusHttp1.value.toString(),
          headers: [],
          body: this.formFields.respuesta1.value.toString(),
        },
        {
          status: this.formFields.statusHttp2.value.toString(),
          headers: [],
          body: this.formFields.respuesta2.value.toString(),
        },
        {
          status: this.formFields.statusHttp3.value.toString(),
          headers: [],
          body: this.formFields.respuesta3.value.toString(),
        },
      ],
    };

    evaluarScriptRespuesta(scriptValidacionRespuesta)
      .then((res: Evaluaciones[]) => {
        this.formFields.resultado1.value = res[0] ? res[0].respuesta : '';
        this.formFields.resultado2.value = res[1] ? res[1].respuesta : '';
        this.formFields.resultado3.value = res[2] ? res[2].respuesta : '';
      })
      .finally(() => this.loadingService.hideLoading());
  }
}
